import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '@helpers/util.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent implements OnInit {
  @Input()
  public imageList: string[] = [];

  @Input() housingPlans: string[] = [];
  @Input() videos: string[] = [];
  @Input() totalPhotos = 0;

  @Input()
  public readonly itemWidth: string = '127px';

  @Input()
  public readonly itemHeight: string = '78px';

  @Output() openGalleria = new EventEmitter<boolean>();

  displayGalleria = false;
  activeIndex = 0;

  @Input()
  carouselVisibleImageCount = 3;

  responsiveOptions: { breakpoint: string; numVisible: number }[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  constructor(public util: UtilService) {}

  ngOnInit(): void {
    if (this.housingPlans.length) this.imageList = this.imageList.concat(this.housingPlans);
  }

  public get carousel(): string[] {
    return this.imageList.length ? this.imageList.slice(0, this.carouselVisibleImageCount + 1) : [];
  }

  public imageClick(index: number): void {
    this.activeIndex = index;
    this.displayGalleria = true;
    this.openGalleria.emit(true);
  }

  public closeGalleria(): void {
    this.openGalleria.emit(false);
  }

  public get imageListGridTemplateColumns() {
    const arr: string[] = [];
    arr.length = this.carouselVisibleImageCount;
    arr.fill(this.itemWidth);
    return arr.join(' ');
  }

  public get itemStyle() {
    return { width: this.itemWidth, height: this.itemHeight };
  }

  public imageURI(id: string): string {
    return `${this.util.getFilePath()}${id}/preview`;
  }

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/no_image.jpeg';
  }
}
